import jQuery from "jquery";
import { EVENT } from "../data/constants";
import DATA from "../data/data";
import SERVICE_REGISTRY from "../services/registry";
import { SETTINGS } from "../settings";
import { LocationProvider } from "../stores-js/location/locationprovider";
import { DirectionsResultsDisplayer } from "../stores-js/ui/directionsresultsdisplayer";
import { OriginDestinationInput } from "../stores-js/ui/origindestinationinput";
import { SearchView } from "../stores-js/ui/searchview";
import templates from "../templates";
import {
    EventManager,
    cleanMapFromRoutes,
    createAutocompleteInput,
    createWoosmapDirectionsProvider,
    getPaddingForWindow,
    initDatePicker,
    onItinaryDateChange,
    resetTrafficElements,
    updateTrafficElements,
} from "../utils/global";
import { hideGeolocationNotice, showGeolocationNotice } from "../utils/notice";
import {
    BlockManager,
    FiltersManager,
    NavigationManager,
    initBlockButtons,
    initRouteOptionButtons,
    initRouteSwitchButton,
    setVisibility,
    updatePOIListHeaderTitle,
} from "../utils/ui";
const $ = jQuery;

export default class SearchOnRouteView extends woosmap.map.MVCObject {
    constructor(sidePanel) {
        super();
        const self = this;
        this.selector = ".wm-route";
        this.sidePanel = sidePanel;
        this.mapView = sidePanel.mapView;
        this.mainElement = $(this.selector);
        this.mainElement.html(
            templates.desktop.searchOnRoute.render({
                ui: total.maps.L10n.ui,
                itinerary: SETTINGS.itinerary,
            }),
        );
        SETTINGS.googleDirectionsRequestOptions.provideRouteAlternatives = false;
        // TO DO !!!OBSERVE THIS COMMENTED LINE
        // SETTINGS.isSearchAlongTheRouteActive = true;

        const onOriginChangedCallback = function () {
            const { location } = this.get("details");
            this.userLocation = location;

            const locationText = location.description;
            const blockSearchNearbyStores = SERVICE_REGISTRY.itinaryService.getDestination() !== null;

            SERVICE_REGISTRY.itinaryService.setOrigin(location);
            SERVICE_REGISTRY.locationService.setLocation(
                location,
                locationText,
                blockSearchNearbyStores,
                "itinerary-origin",
            );
            const destination = SERVICE_REGISTRY.itinaryService.getDestination();
            if (destination) {
                self.woosmapOriginDestinationInput.set("originDestination", {
                    origin: `${location.lng},${location.lat}`,
                    destination: `${destination.lng},${destination.lat}`,
                });
            }
        };
        // Origin search input
        createAutocompleteInput(
            this.mainElement,
            this.mapView.initialBounds,
            templates.desktop.routeOriginSearch,
            "wm-route--origin",
            "origin-predictions-container",
            onOriginChangedCallback,
            false,
        );
        // Destination search input
        const onDestinationLocationChangeCallback = function () {
            const { location } = this.get("details");
            const locationText = self.mainElement.find(".wm-route--origin .wm-route--destination-input").val();
            const blockSearchNearbyStores = SERVICE_REGISTRY.itinaryService.getDestination() !== null;

            SERVICE_REGISTRY.itinaryService.setDestination(location);
            self.mapView.showDestinationMarker(location);

            const origin = SERVICE_REGISTRY.itinaryService.getOrigin();
            if (origin) {
                self.woosmapOriginDestinationInput.set("originDestination", {
                    origin: `${origin.lng},${origin.lat}`,
                    destination: `${location.lng},${location.lat}`,
                });
            }
        };
        createAutocompleteInput(
            this.mainElement,
            this.mapView.initialBounds,
            templates.desktop.destinationSearch,
            "wm-route--destination",
            "destination-predictions-container",
            onDestinationLocationChangeCallback,
            false,
        );

        // Geolocalisation
        this.woosmapNavigatorGeolocation = new LocationProvider();
        this.bindTo("location", this.woosmapNavigatorGeolocation);
        this.woosmapNavigatorGeolocation.location_changed = function () {
            if (this.get("location").source === "html5") {
                const location = this.get("location");
                const blockSearchNearbyStores = SERVICE_REGISTRY.itinaryService.getDestination() !== null;

                SERVICE_REGISTRY.locationService.setLocation(
                    location,
                    total.maps.L10n.ui.common.myLocation,
                    blockSearchNearbyStores,
                    "gps",
                );
                self.mapView.setSearchBounds(null);

                SERVICE_REGISTRY.itinaryService.setOrigin(location);

                const inputElement = self.mainElement.find("#wm-search--container .wm-search--input");
                if (inputElement.val() === "") {
                    inputElement.val(total.maps.L10n.ui.common.myLocation);
                }
            }
        };

        // Direction

        this.woosmapOriginDestinationInput = new OriginDestinationInput(templates.desktop.directions.render(), {
            geolocText: total.maps.L10n.ui.common.myLocation,
        });

        // Add system metric
        const googleDirectionsRequestOptions = $.extend(SETTINGS.googleDirectionsRequestOptions, {
            unitSystem: google.maps.UnitSystem.METRIC,
        });
        this.woosmapDirectionsProvider = createWoosmapDirectionsProvider(
            SETTINGS.directionRendererOptions,
            googleDirectionsRequestOptions,
            () => {},
        );

        this.woosmapDirectionsProvider.bindTo("originDestination", this.woosmapOriginDestinationInput);
        this.woosmapDirectionsProvider.set("selectedTravelMode", "DRIVING");

        this.bindTo("directionsSummaries", this.woosmapDirectionsProvider);
        this.bindTo("directionsRenderers", this.woosmapDirectionsProvider);
        this.bindTo("originDestination", this.woosmapOriginDestinationInput);
        this.woosmapDirectionsResultsDisplayer = new DirectionsResultsDisplayer(this.mapView.map, "", () => {
            const computedDirections = this.woosmapDirectionsResultsDisplayer.get("directionsRenderers")[0].directions;
            const leg = computedDirections.routes[0].legs[0];
            this.buildDirectionsInstructions(leg.steps, this.get("directionsSummaries")[0]);
            if (SERVICE_REGISTRY.storeService.getSelectedStore() !== null) {
                SERVICE_REGISTRY.storeService.resetSelectedStore();
                this.sidePanel.showSearchResultView();
            }
            const mainPanel = document.querySelector(".wm-panel");
            if (!mainPanel.classList.contains("wm-route-mode")) {
                mainPanel.classList.add("wm-route-mode");
            }
        });

        this.woosmapDirectionsResultsDisplayer.bindTo("directionsSummaries", this.woosmapDirectionsProvider);
        this.woosmapDirectionsResultsDisplayer.bindTo("directionsRenderers", this.woosmapDirectionsProvider);

        window.reinitIcons();
        this._wireEvents();
        initRouteSwitchButton();
        this._initDatePicker();
        const mainPanel = document.querySelector(".wm-panel");
        mainPanel.classList.add("wm-route-mode");
    }
    _initDatePicker() {
        const hiddenInput = document.getElementById("route-calendar-input");
        const triggerButton = document.querySelector('[data-id="route-calendar"]');
        initDatePicker(hiddenInput, triggerButton, true, this.woosmapOriginDestinationInput, (selectedDate) =>
            this.onDepartureDateSelectedCb(selectedDate),
        );
    }
    onDepartureDateSelectedCb(selectedDate) {
        console.log("onDepartureDateSelectedCb");
        const selDateEl = document.getElementById("route-departureDt");
        const label = document.getElementById("route-lblDeparture");
        const button = document.querySelector('[data-id="route-departNow"]');
        updateTrafficElements(selectedDate, button, label, selDateEl);
    }
    location_changed() {
        const location = this.get("location");
        this.userLocation = location;

        let originLocation = null;
        const destinationLocation = null;

        if (location && (typeof location.source !== "undefined" || !("source" in location))) {
            const inputElement = this.mainElement.find(".wm-route--origin-input");

            if (!$.isEmptyObject(this.get("location"))) {
                if (inputElement.val() === "") {
                    inputElement.val(total.maps.L10n.ui.common.myLocation).trigger("change");
                }

                originLocation = `${this.get("location").lng},${this.get("location").lat}`;

                if (originLocation && destinationLocation) {
                    this.woosmapOriginDestinationInput.set("originDestination", {
                        origin: originLocation,
                        destination: destinationLocation,
                    });
                }
            } else {
                inputElement.val("");
            }
        }
    }
    _wireEvents() {
        const onPlaceSuggestionClick = function () {
            const liElement = $(this);
            $(".wm-route--origin-input").val(liElement[0].innerText);
            setVisibility("wm-poi-list", "show");
        };
        const onDestSuggestionClick = function () {
            const liElement = $(this);
            $(".wm-route--destination-input").val(liElement[0].innerText);
            BlockManager.handleRouteResults();
        };
        const onOriginInputChanged = () => {
            const inputElement = this.mainElement.find(".wm-route--origin-input");
            if (inputElement.val() !== "") {
                $("#route-location").hide();
                $('[data-id="route-switch"]').show();
            }
        };
        // TO OBSERVE: THIS IS CLASSIC IOS FEATURE/BUG WORKAROUND
        /**Preventing iOS Safari scrolling when focusing on input elements */
        const focusInputWithoutScroll = (selector) => {
            const inputElement = this.mainElement.find(selector);
            if (inputElement.length) {
                const scrollY = window.scrollY;
                inputElement[0].focus({ preventScroll: true });
                // Fallback for iOS Safari
                setTimeout(() => window.scrollTo(0, scrollY), 0);
                inputElement[0].style.opacity = 0;
                setTimeout(() => {
                    inputElement[0].style.opacity = 1;
                });
            }
        };
        const onOriginInputFocused = () => focusInputWithoutScroll(".wm-route--origin-input");
        const onDestInputFocused = () => focusInputWithoutScroll(".wm-route--destination-input");
        const onGeolocatlisationButtonClick = () => {
            hideGeolocationNotice();
            this.woosmapNavigatorGeolocation.askForLocation(navigator.geolocation, (error) => {
                if (error && error.code === error.PERMISSION_DENIED) {
                    showGeolocationNotice();
                }
            });
            EventManager.notify(EVENT.GEOLOCATION_CLICKED, null);
        };
        const reverseDirections = () => {
            const self = this;
            const originDestination = self.woosmapOriginDestinationInput.get("originDestination");

            if (originDestination) {
                self.woosmapOriginDestinationInput.set("originDestination", {
                    origin: originDestination.destination,
                    destination: originDestination.origin,
                });
            }
            SERVICE_REGISTRY.itinaryService.reverseOriginDestination();

            const newOrigin = SERVICE_REGISTRY.itinaryService.getOrigin();
            const newDestination = SERVICE_REGISTRY.itinaryService.getDestination();
            if (newOrigin) {
                self.mapView.locationMarker.setPosition(newOrigin);
            }
            if (newDestination) {
                self.mapView.showDestinationMarker(newDestination);
            }
        };

        const onDepartureNowButtonClick = () => {
            resetTrafficButtons();
            const button = document.querySelector('[data-id="route-departNow"]');
            this.mainElement.find('[data-id="route-departNow"]').toggleClass("wm-active");
            if (button.classList.contains("wm-active")) {
                const newDate = new Date();
                onItinaryDateChange(newDate);
            } else {
                SERVICE_REGISTRY.itinaryService.setStartDatetime(null);
            }
            const originDestination = this.woosmapOriginDestinationInput.get("originDestination");

            if (originDestination) {
                this.woosmapOriginDestinationInput.set("originDestination", {
                    origin: originDestination.origin,
                    destination: originDestination.destination,
                });
            }
        };
        const resetTrafficButtons = () => {
            const selDateEl = document.getElementById("route-departureDt");
            const label = document.getElementById("route-lblDeparture");
            resetTrafficElements(label, selDateEl);
        };

        const setupAvoidFilters = () => {
            const directionOptions = {
                avoidHighways: false,
                avoidTolls: false,
                avoidFerries: false,
            };

            const avoidButtons = this.mainElement.find('[data-id="route-avoid"] button');
            for (const button of avoidButtons) {
                button.addEventListener("click", () => {
                    button.classList.toggle("wm-active");
                    const option = button.getAttribute("data-id");
                    switch (option) {
                        case "highways":
                            directionOptions.avoidHighways = button.classList.contains("wm-active");
                            break;
                        case "tolls":
                            directionOptions.avoidTolls = button.classList.contains("wm-active");
                            break;
                        case "ferries":
                            directionOptions.avoidFerries = button.classList.contains("wm-active");
                            break;
                    }
                    const { avoidHighways, avoidTolls, avoidFerries } = directionOptions;
                    SERVICE_REGISTRY.itinaryService.updateOptions(avoidHighways, avoidTolls, avoidFerries);
                    const originDestination = this.woosmapOriginDestinationInput.get("originDestination");

                    if (originDestination) {
                        this.woosmapOriginDestinationInput.set("originDestination", {
                            origin: originDestination.origin,
                            destination: originDestination.destination,
                        });
                    }
                });
            }
            // Return a reset function to clear both state and UI
            return function resetAvoidOptions() {
                directionOptions.avoidHighways = false;
                directionOptions.avoidTolls = false;
                directionOptions.avoidFerries = false;

                for (const btn of avoidButtons) {
                    btn.classList.remove("wm-active");
                }
                // State only: this runs from the route Cancel button, so rebuilding the
                // directions provider (what updateOptions does) would fire a stray route
                // request during teardown. Toggling a filter still recomputes, via the
                // per-button click handler above.
                SERVICE_REGISTRY.itinaryService.setRouteOptions(directionOptions);
            };
        };
        const resetAvoidButtons = setupAvoidFilters();

        const _resetScheduleButtons = () => {
            const scheduleButtons = this.mainElement.find(".wm-results--schedule .wm-btn--pill");
            for (const btn of scheduleButtons) {
                btn.classList.remove("wm-active");
            }
            SERVICE_REGISTRY.itinaryService.setStartDatetime(null);
        };

        const onCancelSearchOnRoute = () => {
            const self = this;
            hideGeolocationNotice();
            resetAvoidButtons();
            _resetScheduleButtons();
            self.onResetSearchOnRouteView();
            resetTrafficButtons();
        };

        this.mainElement.on("click", ".origin-predictions-container ul li", onPlaceSuggestionClick);
        this.mainElement.on("click", ".destination-predictions-container ul li", onDestSuggestionClick);
        this.mainElement.find(".wm-route--origin-input").change(onOriginInputChanged);
        this.mainElement.find(".wm-route--origin-input").focus(onOriginInputFocused);
        this.mainElement.find(".wm-route--destination-input").focus(onDestInputFocused);
        this.mainElement.on("click", "#route-location", onGeolocatlisationButtonClick);
        this.mainElement.find('[data-id="route-departNow"]').click(onDepartureNowButtonClick);
        $('[data-id="route-switch"]').click(reverseDirections);
        $(document).on("click", ".wm-btn--filter", (e) => {
            this.onItinaryCheckOptionsChange(e);
        });
        this.mainElement.find('[data-id="route-cancel-button"]').click(onCancelSearchOnRoute);
    }
    onResetSearchOnRouteView() {
        SETTINGS.isSearchAlongTheRouteActive = false;
        SERVICE_REGISTRY.locationService.resetLocation();
        SERVICE_REGISTRY.itinaryService.setOrigin(null);
        SERVICE_REGISTRY.itinaryService.setDestination(null);
        SERVICE_REGISTRY.storeService.resetPolylineFilter();
        SERVICE_REGISTRY.storeService.resetStores();
        this.mapView.hideDestinationMarker();
        $(".wm-route--destination-input").val("");
        $(".wm-route--origin-input").val("");
        this.mainElement.find(".origin-predictions-container").hide();
        this.mainElement.find(".destination-predictions-container").hide();
        $("#route-location").show();
        $('[data-id="route-switch"]').hide();
        setVisibility("route-search-button", "show");
        setVisibility("route-details-button", "hide");
        document.querySelector(".wm-results--options").classList.add("wm-hidden");
        NavigationManager.updateButtons("route");
        this.mainElement.find(".wm-results--details-info").html("");
        cleanMapFromRoutes(this.woosmapDirectionsProvider);
        this.mapView.map.fitBounds(this.mapView.initialBounds, getPaddingForWindow());
        updatePOIListHeaderTitle("poi-list-results");
        const mainPanel = document.querySelector(".wm-panel");
        mainPanel.classList.remove("wm-route-mode");
        this._resetRouteDetailsBlock();
    }
    _resetRouteDetailsBlock() {
        const detailsButton = document.querySelector('[data-id="route-details-button"]');
        const expandLabel = detailsButton.querySelector(".wm-btn--label-expand");
        const reduceLabel = detailsButton.querySelector(".wm-btn--label-reduce");
        if (expandLabel) expandLabel.classList.remove("wm-hidden");
        if (reduceLabel) reduceLabel.classList.add("wm-hidden");
    }
    onItinaryCheckOptionsChange(e) {
        const resultsContainer = document.querySelector(".wm-results--options");
        const avoidButtons = resultsContainer.querySelectorAll(".wm-route--avoid .wm-btn--pill");
        const directionOptions = {
            avoidHighways: false,
            avoidTolls: false,
            avoidFerries: false,
        };
        for (const button of avoidButtons) {
            button.classList.toggle("wm-active");
            const option = button.getAttribute("data-id");
            switch (option) {
                case "highways":
                    directionOptions.avoidHighways = button.classList.contains("wm-active");
                    break;
                case "tolls":
                    directionOptions.avoidTolls = button.classList.contains("wm-active");
                    break;
                case "ferries":
                    directionOptions.avoidFerries = button.classList.contains("wm-active");
                    break;
            }
        }
        const { avoidHighways, avoidTolls, avoidFerries } = directionOptions;
        SERVICE_REGISTRY.itinaryService.updateOptions(avoidHighways, avoidTolls, avoidFerries);
    }
    buildDirectionsInstructions(steps, summary) {
        const containerElement = this.mainElement.find(".wm-results--details-info");
        containerElement.html("");
        if (steps && steps.length > 0) {
            for (const step of steps) {
                containerElement.append(
                    `<div class="wm-results--details-info-item">${step.instructions.summary}</div>`,
                );
            }
        } else {
            containerElement.append(
                `<div class="wm-directions--result-title"> ${total.maps.L10n.ui.directions.via} ${summary.summary}</div>
                <div class="wm-directions--result-eta">
                <i data-icon="car" class="wm-poi-detail--section-icon"></i>
                <span class="wm-directions--result-eta-info">${summary.distance} - ${summary.durationShort}</span>
            </div>`,
            );
            window.reinitIcons();
        }
    }
    hide() {
        this.mainElement?.addClass("wm-hidden");
    }
    show() {
        this.mainElement?.removeClass("wm-hidden");
    }
}
